import { render } from "./photoPreview.vue?vue&type=template&id=06db470e"
import script from "./photoPreview.vue?vue&type=script&lang=js"
export * from "./photoPreview.vue?vue&type=script&lang=js"

import "./photoPreview.vue?vue&type=style&index=0&id=06db470e&scope=true&lang=css"

import exportComponent from "D:\\web\\dmsm\\dmsm-pages\\cloud\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__